import { useEffect, useState } from "react";

/**
 * Places of the oscillator panes from engine.events.onPaneLayoutChange: the
 * pane headers follow them and the bottom controls stay above the panes.
 * Re-renders only when a pane moves, not on every frame.
 *
 * @param {object|null} engine - ChartEngine from useChartEngine
 * @returns {object|null} see onPaneLayoutChange; null until the first frame
 */
const usePaneLayout = (engine) => {
  const [paneLayout, setPaneLayout] = useState(null);

  useEffect(() => {
    if (!engine) return undefined;

    const unsubscribe = engine.events.onPaneLayoutChange(setPaneLayout);

    return () => {
      unsubscribe();
      setPaneLayout(null);
    };
  }, [engine]);

  return paneLayout;
};

export default usePaneLayout;
